import { render, staticRenderFns } from "./AllApprovedDetail.vue?vue&type=template&id=05b8fed2&scoped=true"
import script from "./AllApprovedDetail.vue?vue&type=script&lang=js"
export * from "./AllApprovedDetail.vue?vue&type=script&lang=js"
import style0 from "./AllApprovedDetail.vue?vue&type=style&index=0&id=05b8fed2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b8fed2",
  null
  
)

export default component.exports